import React, { FC } from 'react';

import Grid from '@mui/material/Grid';

import DataTable from '../../../sharedModules/dataTable/DataTable/DataTable';

import { HistoryItem } from '../../../salesEstimateModules/estimateRebates/model';

interface ChillerChangeHistoryRowExpandedProps {
  historyItem?: HistoryItem;
  backgroundColor?: string;
}

let changeHistoryColumns = [
  {
    name: 'Field',
    selector: 'field',
  },
  {
    name: 'From',
    selector: 'before_name',
  },
  {
    name: 'To',
    selector: 'after_name',
    cell: (row) => `➡ ${row.after_name}`,
  },
];

const ChillerChangeHistoryRowExpanded: FC<ChillerChangeHistoryRowExpandedProps> = (props) => {
  let { historyItem, backgroundColor } = props;

  return (
    <Grid container style={{ backgroundColor: backgroundColor, padding: '6px' }}>
      <DataTable
        title=""
        columns={changeHistoryColumns}
        data={historyItem?.history_item_lines}
        striped
        dense
        highlightOnHover
        pointerOnHover
        pagination={false}
        noHeader
        noTableHead
      />
    </Grid>
  );
};

export default ChillerChangeHistoryRowExpanded;
